window.getCookie = (cookieName) => {
  var match = document.cookie.match(RegExp('(?:^|;\\s*)' + cookieName + '=([^;]*)')); 
  return match ? match[1] : null;
}

window.setCookie = (cookieName, value, expiryDays) => {
  var expires = "";
  if (expiryDays) {
    var date = new Date();
    date.setTime(date.getTime() + (expiryDays*24*60*60*1000));
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie = cookieName + "=" + (value || "")  + expires + "; path=/";
}

window.deleteCookie = (cookieName) => {
  document.cookie = cookieName +"=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
}
